export default __webpack_public_path__ + "static/media/nc.9f3379ef.svg";